<template>
  <div id="about" style="position: relative;">
    <div v-if="!getMobile" id="navigation">
      <div style="position: relative;">
        <Navigation />
      </div>
    </div>
    <div v-if="getMobile">
      <NavigationMobile />
    </div>

    <div v-if="!getMobile" id="A_introDesktop">
      <div id="logoView" class="centerElement">
        <div>
        </div>
        <div>
        </div>
        <div>
        </div>
      </div>
      <div id="introTextView" class="centerElement">
        <div>
        </div>
        <div>
          <h1 style="color: white; text-shadow: 0 0 2px var(--accentColor); font-size: 4em !important;">
            This is rho 17
          </h1>
        </div>
        <div>
        </div>
      </div>
    </div>

    <img v-if="getMobile"  src="./../../public/img/rho-17-about-m.jpeg" style="height: 100vh; max-width: 100vw; min-height: 670px; position: absolute; top: 0; left: 0; z-index: 0;"/>

    <div v-if="getMobile" style="height: 100vh; min-height: 600px; position: relative;">
      <div id="logoView">
        <div style="margin: auto;">
          <img src="./../../public/icons/logo.svg" width="40%" style="z-index: 1;"/>
        </div>
      </div>
      <div id="introTextViewMobile" class="mobile">
      </div>
    </div>

    <div :class="{centerElement : !getMobile, mobile : getMobile}" id="history">
      <div v-if="!getMobile"></div>
      <div>
        <div>
          <h1>{{getText.history.title}}</h1>
        </div>
        <p>{{getText.history.text}}</p>
      </div>
      <div v-if="!getMobile"></div>
    </div>

    <div class="leftRightElement slideELement" v-if="!getMobile">
      <div style="position:relative;">
        <div class="stickyAnimation">
          <v-hover v-slot="{ hover }" width="100%" style="margin: 0 !important;">
            <v-card elevation="0" width="100%" style="margin: 0 !important;" :class="{ 'on-hover': hover }">
              <v-img src="/img/rho-17-about-julian.jpeg">
                <v-fade-transition>
                  <div v-if="hover" class="transition-fast-in-fast-out whiteOverlay" style="height: 100%;" >
                    <div class="vertical-center">
                      <h2 style="color: var(--mainColor)">{{getText.team.julianTitle}}</h2>
                      <p style="color: var(--mainColor)">{{getText.team.julianText}}</p>
                    </div>
                  </div>
                </v-fade-transition>
              </v-img>
            </v-card>
          </v-hover>
          <!-- <img src="/img/rho-17-about-julian.jpeg" width="100%"/> -->
        </div>
      </div>
      <div >
        <div class="text">
          <h1>
            <span class="mediumLineHeight">{{getText.julian.title}}</span>
          </h1>
          <p style="text-align: left;">
            {{getText.julian.text1}}
          </p>
          <p style="text-align: left;">
            {{getText.julian.text2}}
          </p>
          <p style="text-align: left;">
            {{getText.julian.text3}}
          </p>
        </div>
      </div>
    </div>

    <div v-if="getMobile" style="width: 100%; height: 100vw;">
      <img src="./../../public/img/rho-17-about-julian.jpeg" width="100%" />
    </div>

    <div v-if="getMobile" class="mobile">
      <div class="text">
        <h1>
          <span class="mediumLineHeight">{{getText.julian.title}}</span>
        </h1>
        <p style="text-align: left;">
          {{getText.julian.text1}}
        </p>
        <p style="text-align: left;">
          {{getText.julian.text2}}
        </p>
        <p style="text-align: left;">
          {{getText.julian.text3}}
        </p>
      </div>
    </div>

    <div class="accentColorShadedBackground" :class="{centerElement : !getMobile}" style="padding: 70px 10px 100px 10px; position: relative;">
      <div v-if="!getMobile">
      </div>
      <div>
        <h1 style="position: relative; top: -20px;">
          {{getText.team.title}}
        </h1>
        <p>
          {{getText.team.text1}}
          <br />
          {{getText.team.text2}}
        </p>
      </div>
      <div v-if="!getMobile">
      </div>
    </div>

    <div id="desktopTeamPortraits" v-if="!getMobile">
      <div class="portrait">
        <v-hover v-slot="{ hover }">
          <v-card elevation="0" :class="{ 'on-hover': hover }">
            <v-img width="100%" src="/img/rho-17-about-wing.jpeg">
              <v-fade-transition>
                <div v-if="hover" class="transition-fast-in-fast-out whiteOverlay" style="height: 100%;" >
                  <div class="vertical-center">
                    <h2 style="color: var(--mainColor)">{{getText.team.wingTitle}}</h2>
                    <p style="color: var(--mainColor)">{{getText.team.wingText}}</p>
                  </div>
                </div>
              </v-fade-transition>
            </v-img>
          </v-card>
        </v-hover>
      </div>
      <div class="portrait">
        <v-hover v-slot="{ hover }">
          <v-card elevation="0" :class="{ 'on-hover': hover }">
            <v-img width="100%" src="/img/rho-17-about-elli.jpeg">
              <v-fade-transition>
                <div v-if="hover" class="transition-fast-in-fast-out whiteOverlay" style="height: 100%;" >
                  <div class="vertical-center">
                    <h2 style="color: var(--mainColor)">{{getText.team.elliTitle}}</h2>
                    <p style="color: var(--mainColor)">{{getText.team.elliText}}</p>
                  </div>
                </div>
              </v-fade-transition>
            </v-img>
          </v-card>
        </v-hover>
      </div>
      <div class="portrait">
        <v-hover v-slot="{ hover }">
          <v-card elevation="0" :class="{ 'on-hover': hover }">
            <v-img width="100%" src="/img/rho-17-about-justus.jpeg">
              <v-fade-transition>
                <div v-if="hover" class="transition-fast-in-fast-out whiteOverlay" style="height: 100%;" >
                  <div class="vertical-center">
                    <h2 style="color: var(--mainColor)">{{getText.team.justusTitle}}</h2>
                    <p style="color: var(--mainColor)">{{getText.team.justusText}}</p>
                  </div>
                </div>
              </v-fade-transition>
            </v-img>
          </v-card>
        </v-hover>
      </div>
      <div class="portrait">
        <v-hover v-slot="{ hover }">
          <v-card elevation="0" :class="{ 'on-hover': hover }">
            <v-img width="100%" src="/img/rho-17-about-frieder.jpeg">
              <v-fade-transition>
                <div v-if="hover" class="transition-fast-in-fast-out whiteOverlay" style="height: 100%;" >
                  <div class="vertical-center">
                    <h2 style="color: var(--mainColor)">{{getText.team.friederTitle}}</h2>
                    <p style="color: var(--mainColor)">{{getText.team.friederText}}</p>
                  </div>
                </div>
              </v-fade-transition>
            </v-img>
          </v-card>
        </v-hover>
      </div>
    </div>
    <div v-if="getMobile" style="position: relative; top: -140px;" >
      <v-card class="mx-auto my-12" max-width="90vw" >
        <v-img width="100%" src="/img/rho-17-about-wing.jpeg"></v-img>
        <h2 style="color: var(--mainColor); position: relative; top: 12px;">{{getText.team.wingTitle}}</h2> <br/>
        <p style="color: var(--mainColor); position: relative; bottom: 8px;">{{getText.team.wingText}}</p>
      </v-card>
      <v-card class="mx-auto my-12" max-width="90vw" >
        <v-img width="100%" src="/img/rho-17-about-elli.jpeg"></v-img>
        <h2 style="color: var(--mainColor); position: relative; top: 12px;">{{getText.team.elliTitle}}</h2> <br/>
        <p style="color: var(--mainColor); position: relative; bottom: 8px;">{{getText.team.elliText}}</p>
      </v-card>
      <v-card class="mx-auto my-12" max-width="90vw" >
        <v-img width="100%" src="/img/rho-17-about-justus.jpeg"></v-img>
        <h2 style="color: var(--mainColor); position: relative; top: 12px;">{{getText.team.justusTitle}}</h2> <br/>
        <p style="color: var(--mainColor); position: relative; bottom: 8px;">{{getText.team.justusText}}</p>
      </v-card>
      <v-card class="mx-auto my-12" max-width="90vw" >
        <v-img width="100%" src="/img/rho-17-about-frieder.jpeg"></v-img>
        <h2 style="color: var(--mainColor); position: relative; top: 12px;">{{getText.team.friederTitle}}</h2> <br/>
        <p style="color: var(--mainColor); position: relative; bottom: 8px;">{{getText.team.friederText}}</p>
      </v-card>
    </div>
    <Footer />

  </div>
</template>

<script>
import Navigation from '@/components/Navigation.vue'
import NavigationMobile from '@/components/NavigationMobile.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'About',
  components: {
    Navigation,
    NavigationMobile,
    Footer
  },
  data() {
    return{
      transparent: 'rgba(255, 255, 255, 0)',
    }
   },
   computed: {
     getMobile(){return this.$store.getters.getAnimationProperties.mobile;},
     getText(){return this.$store.getters.getText.about;},
   },
   methods: {
   },
   mounted (){
     this.$store.dispatch("setNavbarActive", 4);
     window.scrollTo(0, 0)
   },
}
</script>

<style scoped>
.vertical-center {
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  text-align: center;
  width: 100%;
}
/* .v-card {
  transition: opacity .2s ease-in-out;
}
.show-text {
  color: var(--mainColor) !important;
}
.v-card:not(.on-hover) {
  opacity: 1;
 }
 .v-card{
   opacity: 0.4;
 } */

.mobile{
  margin: 0 10px;
}
.footerDesktop{
  position: relative;
  top: 100px;
}
#desktopTeamPortraits{
  position: relative;
  top: -90px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 500px;
  margin: auto;
}
.portrait{
  padding: 4px 8px;
}
.whiteOverlay{
  background-color: #ffffff77;
}
#julianBackgroundImage{
  background-image: url('/img/rho-17-about-julian.jpeg');
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
  background-position: bottom left;
}
#A_introDesktop{
  background-image: url('./../../public/img/rho-17-about-d.jpeg');
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
  background-position: bottom left;
  min-height: 105vh;
  position: relative;
}
#A_introMobile{
  background-image: url('./../../public/img/rho-17-about-m.jpeg');
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
  background-position: bottom left;
  min-height: 105vh;
}
#history{
  margin: 90px 0;
}
#logoView{
  height: 50vh;
  padding-top: 20vh;
}
#introTextView{
  position: absolute;
  text-align: center;
  width: 100%;
  top: 35%;
}
#introTextViewMobile{
  height: 400px;
}
#backgroundShade{
  padding: 50px 30px;
  width: 80vw;
  /* height: 280px; */
  background-color: #FFFFFFAA;
}
.slideELement{
  min-height: calc(100vh - var(--desktopNavigationHeight));
}
.stickyAnimation{
  position:sticky;
  top: var(--desktopNavigationHeight);
}
.text{
  padding: 0 10% 0 10%;
}
.mediumLineHeight{
  display: inline-block;
  margin-bottom: 50px;
}

</style>
